export default "__VITE_ASSET__F2dtS0NN__"